import React from 'react';
import { ProfileOutlined } from 'jl-design-system/components/icons/ProfileOutlined';
import styles from './account-button.scss';

export const AccountButton = ({ onClick, greeting, myAccountUrl }) => {
  let accountText = 'Account';

  return (
    <a
      href={myAccountUrl || '/my-account'}
      onClick={onClick}
      data-test="account-button"
      data-testid="account-button"
      className={styles.container}
      aria-label="Go to your account"
    >
      {greeting && <span className={styles.greeting}>{greeting}</span>}

      <ProfileOutlined
        className={styles.icon}
        dataTestId="account-button-icon"
        size="medium"
      />
      <span className={styles.label}>{accountText}</span>
    </a>
  );
};
